import Reflux from "reflux";
import UserNotification from "util/UserNotification";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
export const TYPES = {
  "fs-1": "File system"
};
const urlPrefix = "/plugins/org.graylog.plugins.archive";
export const ArchiveConfigurationActions = Reflux.createActions({
  getConfig: { asyncResult: true },
  saveConfig: { asyncResult: true }
});
const ArchiveConfigurationStore = Reflux.createStore({
  listenables: [ArchiveConfigurationActions],
  filenamesExport: void 0,
  config: void 0,
  getInitialState() {
    return {
      config: void 0
    };
  },
  _errorHandler(message, title, cb) {
    return (error) => {
      let errorMessage;
      try {
        errorMessage = error.additional.body.message;
      } catch (_e) {
        errorMessage = error.message;
      }
      UserNotification.error(`${message}: ${errorMessage}`, title);
      if (cb) {
        cb(error);
      }
    };
  },
  _configUrl() {
    return qualifyUrl(`${urlPrefix}/config`);
  },
  _archivesUrl(path) {
    return qualifyUrl(`${urlPrefix}/cluster/archives${path}`);
  },
  _url(path) {
    return qualifyUrl(`${urlPrefix}${path}`);
  },
  getConfig() {
    const promise = fetch("GET", this._configUrl());
    promise.then(
      (response) => {
        this.config = response;
        this.trigger({ config: response });
      },
      this._errorHandler("Fetching config failed", "Could not retrieve archive config")
    );
    ArchiveConfigurationActions.getConfig.promise(promise);
  },
  saveConfig(config) {
    const promise = fetch("PUT", this._configUrl(), config);
    promise.then(
      (response) => {
        this.config = response;
        this.trigger({ config: response });
        UserNotification.success("Archive configuration was updated successfully");
      },
      this._errorHandler("Updating archive config failed", "Unable to update archive config")
    );
    ArchiveConfigurationActions.saveConfig.promise(promise);
  }
});
export default ArchiveConfigurationStore;
